@if (!dismissed() && store.count() > 0) {
  <div
    class="w-full bg-primary-500 text-white px-4 py-2.5 flex items-center justify-center gap-4 text-sm flex-wrap"
  >
    <span class="flex items-center gap-2">
      <i class="pi pi-check-circle"></i>
      @if (store.count() === 1) {
        <span>{{ 'paymentRecoveryBanner.singleMessage' | transloco }}</span>
      } @else {
        <span>{{
          'paymentRecoveryBanner.multipleMessage' | transloco: { count: store.count() }
        }}</span>
      }
    </span>
    <p-button
      [label]="'paymentRecoveryBanner.continueButton' | transloco"
      size="small"
      severity="contrast"
      [outlined]="true"
      (onClick)="resume()"
    />
    <button
      type="button"
      class="text-white/80 hover:text-white transition-colors"
      [attr.aria-label]="'paymentRecoveryBanner.closeAriaLabel' | transloco"
      (click)="dismiss()"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
}
